'use strict';

var sso = require('@aws-sdk/nested-clients/sso');



exports.GetRoleCredentialsCommand = sso.GetRoleCredentialsCommand;
exports.SSOClient = sso.SSOClient;
